import React from 'react';
import { useLanguage, useScrollToTop } from '../hooks';
import './PrivacyPolicy.css';

const policy = {
  md: {
    title: 'Politica de confidențialitate',
    updated: 'Ultima actualizare: 26 august 2026',
    intro:
      'VIPROPAT SRL respectă viața privată și prelucrează datele cu caracter personal în conformitate cu Legea nr. 195/2024 privind protecția datelor cu caracter personal.',
    controllerTitle: '1. Operatorul datelor',
    controller:
      'Operator: VIPROPAT SRL. Adresă: Republica Moldova, MD-2068, mun. Chișinău, str. Miron Costin 7, aripa dreaptă, of. 408. E-mail pentru întrebări și exercitarea drepturilor: info@cogeneration.md. Telefon: +373 69 127 963.',
    processingTitle: '2. Ce date prelucrăm, în ce scop și pentru cât timp',
    headers: ['Activitate', 'Date și scop', 'Temei juridic', 'Păstrare'],
    rows: [
      [
        'Solicitări de contact',
        'Nume, e-mail, subiect, mesaj și datele tehnice strict necesare livrării și securizării solicitării; pentru a răspunde și a pregăti o ofertă.',
        'Demersuri la cererea persoanei înainte de încheierea unui contract sau interesul legitim de a răspunde solicitărilor.',
        'Până la 12 luni de la ultimul răspuns, dacă nu începe o relație contractuală sau nu există o obligație legală mai lungă.',
      ],
      [
        'Recrutare',
        'CV, date de contact, experiență, studii și informațiile oferite voluntar; pentru evaluarea candidaturii.',
        'Demersuri înaintea încheierii unui contract de muncă și obligații în domeniul muncii. Nu trimiteți date sensibile care nu sunt necesare.',
        'Pe durata recrutării și cel mult 6 luni după încheierea ei. Păstrarea pentru oportunități viitoare se face numai cu un acord separat.',
      ],
      [
        'Funcționarea și securitatea site-ului',
        'Adresă IP, agent utilizator, momentul și resursa solicitată în jurnalele serverului; pentru securitate, depanare și prevenirea abuzului.',
        'Interes legitim privind securitatea și funcționarea serviciului.',
        'În mod obișnuit 30 de zile, mai mult numai când este necesar investigării unui incident.',
      ],
      [
        'Preferințe necesare',
        'Limba aleasă și preferințele de confidențialitate sunt memorate pe dispozitiv pentru funcționarea site-ului și păstrarea alegerii.',
        'Necesitatea funcțională și interesul legitim privind furnizarea setărilor solicitate.',
        'Până la ștergerea lor de către utilizator sau schimbarea versiunii preferințelor.',
      ],
      [
        'Google Analytics – opțional',
        'Identificatori online și interacțiuni cu paginile; pentru statistici agregate și îmbunătățirea site-ului. Semnalele pentru publicitate sunt dezactivate.',
        'Consimțământ, care poate fi retras oricând din Preferințe de confidențialitate.',
        'Conform setării proprietății Analytics, vizată la maximum 14 luni.',
      ],
      [
        'Google Maps – opțional',
        'La activare, Google primește date tehnice precum adresa IP și informații despre dispozitiv pentru a afișa harta.',
        'Consimțământ, care poate fi retras oricând.',
        'Stabilită de Google conform politicilor sale.',
      ],
    ],
    recipientsTitle: '3. Destinatari și transferuri',
    recipients:
      'Datele pot fi accesate, strict în măsura necesară, de furnizorii contractați de găzduire, e-mail și mentenanță IT. Dacă activați serviciile opționale, Google poate prelucra date în alte state. Transferurile trebuie să se bazeze pe o decizie de adecvare, clauze contractuale standard sau alte garanții permise de art. 44–50 din Legea nr. 195/2024. Nu vindem date personale.',
    google:
      'Informații Google: https://policies.google.com/privacy și https://business.safety.google/privacy/',
    rightsTitle: '4. Drepturile dvs.',
    rights:
      'Puteți solicita accesul, rectificarea, ștergerea, restricționarea, portabilitatea datelor și vă puteți opune prelucrării. Când temeiul este consimțământul, îl puteți retrage fără a afecta prelucrarea anterioară. Trimiteți cererea la info@cogeneration.md. Răspundem, de regulă, în cel mult o lună; putem solicita informații rezonabile pentru verificarea identității.',
    complaint:
      'Aveți dreptul să depuneți o plângere la Centrul Național pentru Protecția Datelor cu Caracter Personal: datepersonale.md, str. Serghei Lazo 48, MD-2004, Chișinău.',
    requiredTitle: '5. Caracterul furnizării datelor',
    required:
      'Datele marcate obligatoriu în formular sunt necesare pentru a vă răspunde. Fără ele nu putem procesa solicitarea. Furnizarea altor informații este voluntară. Nu realizăm decizii exclusiv automatizate sau profilare cu efecte juridice.',
    securityTitle: '6. Securitate și incidente',
    security:
      'Aplicăm măsuri tehnice și organizatorice proporționale riscului, inclusiv transport criptat, controlul accesului, validarea solicitărilor, minimizarea și termene de ștergere. Incidentele sunt evaluate și, atunci când legea o cere, notificate CNPDCP în cel mult 72 de ore și persoanelor afectate fără întârzieri nejustificate.',
    childrenTitle: '7. Copii și modificări',
    children:
      'Site-ul este destinat profesioniștilor și nu urmărește colectarea datelor copiilor. Putem actualiza această politică; data versiunii curente este afișată la început.',
  },
  ru: {
    title: 'Политика конфиденциальности',
    updated: 'Последнее обновление: 26 августа 2026 г.',
    intro:
      'VIPROPAT SRL уважает частную жизнь и обрабатывает персональные данные в соответствии с Законом № 195/2024 о защите персональных данных.',
    controllerTitle: '1. Оператор данных',
    controller:
      'Оператор: VIPROPAT SRL. Адрес: Республика Молдова, MD-2068, Кишинёв, ул. Мирон Костин 7, правое крыло, офис 408. Запросы и осуществление прав: info@cogeneration.md. Телефон: +373 69 127 963.',
    processingTitle: '2. Какие данные, зачем и как долго мы обрабатываем',
    headers: ['Действие', 'Данные и цель', 'Правовое основание', 'Срок'],
    rows: [
      [
        'Обращения',
        'Имя, e-mail, тема, сообщение и минимальные технические данные; ответ на запрос и подготовка предложения.',
        'Действия по запросу до заключения договора либо законный интерес ответить на обращение.',
        'До 12 месяцев после последнего ответа, если не возник договор или более длительная законная обязанность.',
      ],
      [
        'Подбор персонала',
        'Резюме, контакты, опыт, образование и добровольно предоставленная информация; оценка кандидата.',
        'Действия до заключения трудового договора и обязанности трудового права. Не присылайте ненужные чувствительные данные.',
        'Во время подбора и не более 6 месяцев после него. Для будущих вакансий — только с отдельного согласия.',
      ],
      [
        'Работа и безопасность сайта',
        'IP-адрес, пользовательский агент, время и запрошенный ресурс в журналах сервера; безопасность, диагностика и предотвращение злоупотреблений.',
        'Законный интерес в безопасности и работе сервиса.',
        'Обычно 30 дней; дольше только для расследования инцидента.',
      ],
      [
        'Обязательные настройки',
        'Язык и выбор конфиденциальности хранятся на устройстве для работы сайта и запоминания выбора.',
        'Функциональная необходимость и законный интерес предоставить запрошенные настройки.',
        'До удаления пользователем или изменения версии настроек.',
      ],
      [
        'Google Analytics — по выбору',
        'Онлайн-идентификаторы и действия на страницах; агрегированная статистика и улучшение сайта. Рекламные сигналы отключены.',
        'Согласие, которое можно отозвать в настройках конфиденциальности.',
        'Согласно настройке Analytics — целевой максимум 14 месяцев.',
      ],
      [
        'Google Maps — по выбору',
        'После включения Google получает технические данные, включая IP и сведения об устройстве, чтобы показать карту.',
        'Согласие, которое можно отозвать в любое время.',
        'Определяется Google согласно его правилам.',
      ],
    ],
    recipientsTitle: '3. Получатели и международная передача',
    recipients:
      'Доступ в необходимом объёме могут иметь договорные поставщики хостинга, электронной почты и ИТ-поддержки. При включении дополнительных сервисов Google может обрабатывать данные в других государствах. Передача должна основываться на решении об адекватности, стандартных договорных положениях или иных гарантиях по ст. 44–50 Закона № 195/2024. Мы не продаём персональные данные.',
    google:
      'Информация Google: https://policies.google.com/privacy и https://business.safety.google/privacy/',
    rightsTitle: '4. Ваши права',
    rights:
      'Вы можете запросить доступ, исправление, удаление, ограничение, перенос данных и возразить против обработки. Согласие можно отозвать без влияния на предыдущую законную обработку. Напишите на info@cogeneration.md. Обычно мы отвечаем в течение одного месяца и можем запросить разумные сведения для проверки личности.',
    complaint:
      'Вы вправе подать жалобу в Национальный центр защиты персональных данных: datepersonale.md, MD-2004, Кишинёв, ул. Сергей Лазо 48.',
    requiredTitle: '5. Обязательность данных',
    required:
      'Отмеченные обязательными данные нужны для ответа. Без них мы не сможем обработать запрос. Остальная информация добровольна. Мы не принимаем исключительно автоматизированных решений и не выполняем профилирование с юридическими последствиями.',
    securityTitle: '6. Безопасность и инциденты',
    security:
      'Мы применяем соразмерные риску технические и организационные меры: шифрование передачи, контроль доступа, проверку запросов, минимизацию и сроки удаления. Когда закон этого требует, об инцидентах сообщается CNPDCP не позднее 72 часов и затронутым лицам без неоправданной задержки.',
    childrenTitle: '7. Дети и изменения',
    children:
      'Сайт предназначен для профессиональной аудитории и не ставит целью сбор данных детей. Политика может обновляться; дата текущей версии указана в начале.',
  },
  en: {
    title: 'Privacy policy',
    updated: 'Last updated: 26 August 2026',
    intro:
      'VIPROPAT SRL respects privacy and processes personal data in accordance with Moldova’s Law No. 195/2024 on Personal Data Protection.',
    controllerTitle: '1. Data controller',
    controller:
      'Controller: VIPROPAT SRL. Address: MD-2068, 7 Miron Costin Street, right wing, office 408, Chișinău, Republic of Moldova. Privacy and rights requests: info@cogeneration.md. Phone: +373 69 127 963.',
    processingTitle: '2. What we process, why, and for how long',
    headers: ['Activity', 'Data and purpose', 'Legal basis', 'Retention'],
    rows: [
      [
        'Contact enquiries',
        'Name, email, subject, message, and minimal technical delivery/security data; to answer and prepare an offer.',
        'Steps requested before a contract or our legitimate interest in answering enquiries.',
        'Up to 12 months after the last response unless a contract or longer legal duty applies.',
      ],
      [
        'Recruitment',
        'CV, contact details, experience, education, and information supplied voluntarily; to assess an application.',
        'Pre-employment steps and employment-law obligations. Please do not send unnecessary sensitive data.',
        'During recruitment and up to 6 months afterwards. Future-opportunity retention requires separate consent.',
      ],
      [
        'Site operation and security',
        'IP address, user agent, time, and requested resource in server logs; security, troubleshooting, and abuse prevention.',
        'Legitimate interests in operating and securing the service.',
        'Normally 30 days; longer only where needed to investigate an incident.',
      ],
      [
        'Necessary preferences',
        'Language and privacy choices are stored on the device to operate the site and remember the choice.',
        'Functional necessity and legitimate interests in providing requested settings.',
        'Until the user deletes them or the preference version changes.',
      ],
      [
        'Google Analytics — optional',
        'Online identifiers and page interactions; aggregate statistics and site improvement. Advertising signals are disabled.',
        'Consent, withdrawable at any time through Privacy preferences.',
        'According to the Analytics property setting, targeted at no more than 14 months.',
      ],
      [
        'Google Maps — optional',
        'When enabled, Google receives technical data such as IP address and device information to display the map.',
        'Consent, withdrawable at any time.',
        'Set by Google under its policies.',
      ],
    ],
    recipientsTitle: '3. Recipients and international transfers',
    recipients:
      'Contracted hosting, email, and IT-maintenance providers may access data only as necessary. If optional Google services are enabled, Google may process data in other countries. Transfers must rely on an adequacy decision, standard contractual clauses, or another safeguard permitted by Articles 44–50 of Law No. 195/2024. We do not sell personal data.',
    google:
      'Google information: https://policies.google.com/privacy and https://business.safety.google/privacy/',
    rightsTitle: '4. Your rights',
    rights:
      'You may request access, correction, deletion, restriction, and portability, and may object to processing. Where processing relies on consent, you may withdraw it without affecting earlier lawful processing. Email info@cogeneration.md. We normally respond within one month and may request reasonable information to verify identity.',
    complaint:
      'You may complain to the National Center for Personal Data Protection: datepersonale.md, 48 Serghei Lazo Street, MD-2004, Chișinău.',
    requiredTitle: '5. Whether data is required',
    required:
      'Fields marked as required are needed to answer you. Without them we cannot process the enquiry. Other information is voluntary. We do not make solely automated decisions or perform profiling with legal effects.',
    securityTitle: '6. Security and incidents',
    security:
      'We apply risk-appropriate technical and organisational measures, including encrypted transport, access control, request validation, minimisation, and deletion periods. Where required, incidents are reported to CNPDCP within 72 hours and affected people without undue delay.',
    childrenTitle: '7. Children and changes',
    children:
      'The site is intended for professional audiences and does not seek to collect children’s data. We may update this policy; the current version date appears above.',
  },
};

const linkify = (text) => {
  const parts = text.split(/(https?:\/\/[^\s]+|[\w.+-]+@[\w.-]+\.[A-Za-z]{2,})/g);
  return parts.map((part, index) => {
    if (part.startsWith('http')) {
      const clean = part.replace(/[.,]$/, '');
      return (
        <a key={`${part}-${index}`} href={clean} target="_blank" rel="noreferrer">
          {clean}
        </a>
      );
    }
    if (part.includes('@'))
      return (
        <a key={`${part}-${index}`} href={`mailto:${part}`}>
          {part}
        </a>
      );
    return part;
  });
};

const PrivacyPolicy = () => {
  useScrollToTop();
  const { lang } = useLanguage();
  const text = policy[lang] || policy.md;

  return (
    <main className="policy-page">
      <article className="policy-card">
        <h1>{text.title}</h1>
        <p className="policy-updated">{text.updated}</p>
        <p>{text.intro}</p>
        <h2>{text.controllerTitle}</h2>
        <p>{linkify(text.controller)}</p>
        <h2>{text.processingTitle}</h2>
        <div className="policy-table-wrap">
          <table>
            <thead>
              <tr>
                {text.headers.map((header) => (
                  <th key={header}>{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {text.rows.map((row) => (
                <tr key={row[0]}>
                  {row.map((cell) => (
                    <td key={cell}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <h2>{text.recipientsTitle}</h2>
        <p>{text.recipients}</p>
        <p>{linkify(text.google)}</p>
        <h2>{text.rightsTitle}</h2>
        <p>{linkify(text.rights)}</p>
        <p>{linkify(text.complaint)}</p>
        <h2>{text.requiredTitle}</h2>
        <p>{text.required}</p>
        <h2>{text.securityTitle}</h2>
        <p>{text.security}</p>
        <h2>{text.childrenTitle}</h2>
        <p>{text.children}</p>
      </article>
    </main>
  );
};

export default PrivacyPolicy;
